export default __webpack_public_path__ + "static/media/SLSTM3.0e772885.png";